import { AxiosError } from 'axios';

import { createAsyncThunk } from '@reduxjs/toolkit';

import { usersApi } from '@/api/index';

export const fetchCurrentUser = createAsyncThunk(
  'currentUser',
  async (params, thunkAPI) => {
    try {
      const response = await usersApi.getCurrent();
      return response ? response.data : [];
    } catch (e) {
      if (e instanceof AxiosError) {
        return thunkAPI.rejectWithValue(e.message);
      }
      throw e;
    }
  },
);

export const fetchCurrentUserLogo = createAsyncThunk(
  'currentUserLogo',
  async (params, thunkAPI) => {
    try {
      const response = await usersApi.getCurrentLogo();
      return response ? response.data : [];
    } catch (e) {
      if (e instanceof AxiosError) {
        return thunkAPI.rejectWithValue(e.message);
      }
      throw e;
    }
  },
);
